import { styled, css } from '../../theme'

interface CellProps {
  mobile?: number
  tablet?: number
  desktop?: number
  verticalGutter?: boolean
}

export const Col = styled.div.attrs({})<CellProps>`
  flex: 0 0 auto;
  padding-right: ${p => p.theme.grid.gap.mobile / 2}px;
  padding-left: ${p => p.theme.grid.gap.mobile / 2}px;
  padding-bottom: ${p => p.verticalGutter && `${p.theme.grid.gap.mobile}px`};

  flex-grow: 1;
  flex-basis: 0;
  max-width: 100%;

  ${p => p.theme.media.tablet`
    padding-right: ${p.theme.grid.gap.tablet / 2}px;
    padding-left: ${p.theme.grid.gap.tablet / 2}px;
    padding-bottom: ${p.verticalGutter && `${p.theme.grid.gap.tablet}px`};
  `};

  ${p => p.theme.media.desktop`
    padding-right: ${p.theme.grid.gap.desktop / 2}px;
    padding-left: ${p.theme.grid.gap.desktop / 2}px;
    padding-bottom: ${p.verticalGutter && `${p.theme.grid.gap.desktop}px`};
  `};

  ${p =>
    p.mobile
      ? css`
          flex-basis: ${(100 / 12) * p.mobile}%;
          max-width: ${(100 / 12) * p.mobile}%;
        `
      : css`
          flex-grow: 1;
          flex-basis: 0;
          max-width: 100%;
        `};

  ${p =>
    !p.mobile &&
    (p.tablet || p.desktop) &&
    css`
      flex-basis: 100%;
      max-width: 100%;
    `};

  ${p =>
    p.tablet &&
    p.theme.media.tablet`
    flex-basis: ${(100 / 12) * p.tablet}%;
    max-width: ${(100 / 12) * p.tablet}%;
  `};

  ${p =>
    p.desktop &&
    p.theme.media.desktop`
    flex-basis: ${(100 / 12) * p.desktop}%;
    max-width: ${(100 / 12) * p.desktop}%;
  `};
`
